import { ofType } from "redux-observable";
import { EMPTY, of } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import { utilBuildings } from "../../../utils/utilBuildings";
import { TypeActionBuildings } from "../../player-base/buildings/actionBuildings";
import { actionViewportCenterOn } from "../actionViewport";
export var epicViewportCenter = function (action$, state$) {
    return action$.pipe(ofType(TypeActionBuildings.Select), filter(function (action) { return !utilBuildings.hasFinishedProduction(action.building); }), switchMap(function (action) {
        var pos = action.buildingCenterCoords;
        if (pos == undefined || !action.centerOnBuilding) {
            return EMPTY;
        }
        // We have to shift the centering up a bit to leave place for UI elements
        pos.y += window.innerHeight * 0.1;
        return of(actionViewportCenterOn(pos));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/viewport/epics/epicViewportCenter.ts
// module id = 2499
// module chunks = 3